import Vuex from 'vuex'
import Vue from "vue";
import { config } from "vuex-module-decorators";
import ViewpointsModule from "@/store/viewpoint/viewpoint";
import DecisionModule from "@/store/decision/Decision";

Vue.use(Vuex)

config.rawError = true

interface StoreType {
    viewpoints: ViewpointsModule,
    decisions: DecisionModule

}

const store = new Vuex.Store<StoreType>({
    /*
    Ideally if all your modules are dynamic
    then your store is registered initially
    as a completely empty object
    */
});

export default store;